import { notificationsApi } from "../api";

/**
 * 🔔 Servicio frontend de notificaciones
 *
 * Conectado con:
 * /api/notifications
 */
const NotificationService = {
    /**
     * 📬 Obtener notificaciones del usuario
     *
     * onlyUnread = true → solo no leídas
     */
    fetchUserNotifications: async (
        onlyUnread: boolean = false
    ) => {
        try {
            const route = onlyUnread
                ? "/user-notifications?onlyUnread=true"
                : "/user-notifications";

            const response =
                await notificationsApi.fetchCustom(route);

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error obteniendo notificaciones:",
                error
            );
            throw error;
        }
    },

    /**
     * ✅ Marcar como leída
     */
    markAsRead: async (
        notificationId: string
    ) => {
        try {
            const response =
                await notificationsApi.modifyCustom(
                    `/mark-as-read/${notificationId}`,
                    {}
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error marcando notificación:",
                error
            );
            throw error;
        }
    },

    /**
     * 🔢 Obtener contador de no leídas
     *
     * IMPORTANTE:
     * backend usa:
     * /unread-count
     *
     * NO:
     * /total-count
     */
    fetchTotalCount: async () => {
        try {
            const response =
                await notificationsApi.fetchCustom(
                    "/unread-count"
                );

            // backend devuelve:
            // {
            //   userId,
            //   unreadCount
            // }

            return response.data.unreadCount;

        } catch (error) {
            console.error(
                "❌ Error obteniendo contador:",
                error
            );
            throw error;
        }
    },
};

export default NotificationService;